<section class="main-content wrapper content-padding " style="margin-top: 80px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab" *ngIf="groups.includes('expert')">
        <a
          class="tab-link"
          routerLink="/activities/own"
          routerLinkActive="active-tab"
        >
          OWN ACTIVITIES
        </a>
      </label>
  
      <label class="tab" *ngIf="((groups.includes('expert') && currentExpert?.isTeamLeader) || groups.includes('admin') || groups.includes('operation') )">
        <a
          class="tab-link"
          routerLink="/activities/other/valet"
          routerLinkActive="active-tab"
        >
          {{ (groups.includes('expert') && currentExpert?.isTeamLeader) ? "OTHER VALET ACTIVITIES" : "VALET ACTIVITIES" }} 
        </a>
      </label>
    </div>
    <router-outlet></router-outlet>
  </div>
</section>
